import React, { lazy } from 'react';

// 机器人登录页
const LoginForRobot = lazy(() => import('@/pages/robotForStudent/Login'));
const RobotHome = lazy(() => import('@/pages/robotForStudent/Home'));
const PsychologicalAIConsultantWithPrompt = lazy(() => import('@/pages/robotForStudent/PsychologicalAIConsultation/PsychologicalAIConsultantWithPrompt'));
const PsychologicalAIConsultant = lazy(() => import('@/pages/robotForStudent/PsychologicalAIConsultation'));
const PsychologicalAIEvaluation = lazy(() => import('@/pages/robotForStudent/PsychologicalAIConsultation/PsychologicalAIEvaluation'));
const TaskList = lazy(() => import('@/pages/robotForStudent/TaskList'));


const robotRoutes = [
  { path: '/robot-std/login', component: <LoginForRobot />, needInterceptor: false },
  { path: '/robot-std/home', component: <RobotHome />, needInterceptor: true },
  { path: '/robot-std/psychological-ai-consultant-with-prompt', component: <PsychologicalAIConsultantWithPrompt />, needInterceptor: true },
  { path: '/robot-std/psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
  { path: '/robot-std/psychological-ai-evaluation', component: <PsychologicalAIEvaluation />, needInterceptor: true },
  { path: '/robot-std/psychological-ai-evaluation', component: <PsychologicalAIEvaluation />, needInterceptor: true },
  { path: '/robot-std/task-list', component: <TaskList />, needInterceptor: true },
  
];

export default robotRoutes;
